module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('el-form', {
    ref: "ecxForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.ecxForm,
      "rules": _vm.actrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "提货码名称",
      "prop": "excodeName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "提货码信息名称"
    },
    model: {
      value: (_vm.ecxForm.excodeName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "excodeName", $$v)
      },
      expression: "ecxForm.excodeName"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.productList), function(item, index) {
    return (_vm.productList.length > 0) ? _c('el-form-item', {
      attrs: {
        "label": "商品名称"
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "30%"
      },
      attrs: {
        "value": item.name,
        "disabled": "disabled"
      }
    }), _vm._v(" "), _c('el-button', {
      on: {
        "click": function($event) {
          _vm.delProductInfo(index)
        }
      }
    }, [_vm._v("删除")])], 1) : _vm._e()
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提货码信息类型",
      "prop": "excodeType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "提货码信息类型"
    },
    on: {
      "change": function($event) {
        _vm.showFile()
      }
    },
    model: {
      value: (_vm.ecxForm.excodeType),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "excodeType", $$v)
      },
      expression: "ecxForm.excodeType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "系统生成"
    }
  }, [_vm._v("系统生成")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "预生成"
    }
  }, [_vm._v("预生成")])], 1), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow),
      expression: "isShow"
    }],
    on: {
      "click": function($event) {
        _vm.export2Excel()
      }
    }
  }, [_vm._v("生成取货码表格")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "机器编号",
      "prop": "kioskNo"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "机器编号"
    },
    on: {
      "change": function($event) {
        _vm.getProductList()
      }
    },
    model: {
      value: (_vm.ecxForm.kioskNo),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "kioskNo", $$v)
      },
      expression: "ecxForm.kioskNo"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "K1-A112",
      "value": "K1-A112"
    }
  }, [_vm._v("K1-A112")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提货码商品信息",
      "prop": "product"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "提货码商品信息"
    },
    model: {
      value: (_vm.prodindex),
      callback: function($$v) {
        _vm.prodindex = $$v
      },
      expression: "prodindex"
    }
  }, _vm._l((_vm.products), function(item, index) {
    return _c('el-option', {
      attrs: {
        "label": item.productName,
        "value": index
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.setProductInfo()
      }
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出货类型",
      "prop": "productType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "出货类型"
    },
    model: {
      value: (_vm.ecxForm.productType),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "productType", $$v)
      },
      expression: "ecxForm.productType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "All",
      "label": "全部出货"
    }
  }, [_vm._v("全部出货")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "Ran",
      "label": "随机一件"
    }
  }, [_vm._v("随机一件")])], 1)], 1), _vm._v(" "), (_vm.ecxForm.excodeType == 0) ? _c('el-form-item', {
    attrs: {
      "label": "提货码总数量",
      "prop": "count"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "提货码总数量"
    },
    model: {
      value: (_vm.ecxForm.count),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "count", $$v)
      },
      expression: "ecxForm.count"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提货码备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "提货码备注"
    },
    model: {
      value: (_vm.ecxForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "remark", $$v)
      },
      expression: "ecxForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动开始时间",
      "prop": "startTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.getStartTime
    },
    model: {
      value: (_vm.ecxForm.startTime),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "startTime", $$v)
      },
      expression: "ecxForm.startTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动结束时间",
      "prop": "endTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期"
    },
    on: {
      "change": _vm.getEndTime
    },
    model: {
      value: (_vm.ecxForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "endTime", $$v)
      },
      expression: "ecxForm.endTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提货码刷新周期",
      "prop": "isExp"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "提货码刷新周期"
    },
    on: {
      "change": function($event) {
        _vm.isExpType()
      }
    },
    model: {
      value: (_vm.ecxForm.isExp),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "isExp", $$v)
      },
      expression: "ecxForm.isExp"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "不刷新"
    }
  }, [_vm._v("不刷新")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "刷新"
    }
  }, [_vm._v("刷新")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isexpSecond),
      expression: "isexpSecond"
    }],
    attrs: {
      "label": "提货码刷新时长(秒)",
      "prop": "expSecond"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "提货码刷新时长"
    },
    model: {
      value: (_vm.ecxForm.expSecond),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "expSecond", $$v)
      },
      expression: "ecxForm.expSecond"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态",
      "prop": "status"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.radioStatus
    },
    model: {
      value: (_vm.ecxForm.status),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "status", $$v)
      },
      expression: "ecxForm.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0",
      "value": "0"
    }
  }, [_vm._v("停用")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fileList"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadurl,
      "data": _vm.upload_data,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handletype,
      "file-list": _vm.ecxForm.fileList
    }
  }, [_c('span', {
    class: {
      isable: _vm.isorno
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("大小不超过5GB")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "表格名称",
      "prop": "exlName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "videoUrl"
    },
    model: {
      value: (_vm.ecxForm.exlName),
      callback: function($$v) {
        _vm.$set(_vm.ecxForm, "exlName", $$v)
      },
      expression: "ecxForm.exlName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "id": "primary",
      "disabled": _vm.isorgsubmit
    },
    on: {
      "click": function($event) {
        _vm.submitForm('ecxForm')
      }
    }
  }, [_vm._v("确 定")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.resetForm('ecxForm')
      }
    }
  }, [_vm._v("重 置")])], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0cba3f7d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/excode/ExcodeAdd.vue
// module id = 1032
// module chunks = 2